import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import PaginationTable from '../../pagination/Pagination4';
import { formatDateToDD_MM_YYYY_HH_MM_SS } from "../../Utils/DateUtils";


const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const KeyRegisterAllotDist_data = async (month, year, fps_id) => {
    const response = await fetch(`${process.env.REACT_APP_URL_FPS}/fps/fpstransaction?fpsId=${fps_id}&month=${month}&year=${year}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const FPS_Trans_Details = ({ month, year, fps_id, heading }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(heading);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [searchQuery, setSearchQuery] = useState('');
    const [totals, setTotals] = useState([]); // State for storing column totals
    const [amountTotals, setAmountTotals] = useState([]);

    const detailsTrans = useRef(null);

    const calculateTotals = (data) => {
        const amountTotal = data.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
        setAmountTotals([amountTotal]);
        const columnCount = data[0].commodityList.length;
        const columnTotals = new Array(columnCount).fill(0); // Initialize an array for totals

        data.forEach(item => {
            item.commodityList.forEach((colItem, colIndex) => {
                columnTotals[colIndex] += parseFloat(colItem.sale_qty) || 0; // Sum each column's allot_qty

            });

        });

        setTotals(columnTotals);
    };


    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await KeyRegisterAllotDist_data(month, year, fps_id);

                if (Array.isArray(response_data)) {
                    setReportData(response_data);

                    if (response_data.length > 0)
                        calculateTotals(response_data);

                } else {
                    setReportData([]);
                }
            } catch (error) {
                console.log(error);
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [month, year, fps_id]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (value) => {
        setRowsPerPage(value === 'all' ? reportData.length : parseInt(value, 10));
        setPage(0);
    };

    const filteredData = reportData.filter(item => {
        const searchLower = searchQuery.toLowerCase();

        return (
            item.existingRcNumber?.toLowerCase().includes(searchLower) ||
            item.schemeShortName?.toLowerCase().includes(searchLower) ||
            item.auth_type?.toLowerCase().includes(searchLower) ||
            item.receiptId?.toString().toLowerCase().includes(searchLower) ||
            formatDateToDD_MM_YYYY_HH_MM_SS(item.loginTime)?.toLowerCase().includes(searchLower) ||
            item.amount?.toString().includes(searchLower) ||
            item.portCheck?.toLowerCase().includes(searchLower) ||
            item.transTime?.toLowerCase().includes(searchLower) ||

            item.commodityList?.some(commodity =>
                commodity.comm_name_en?.toLowerCase().includes(searchLower) ||
                commodity.sale_qty?.toString().includes(searchLower)
            )
        );
    });

    // Ensure pagination logic is correct
    const paginatedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const exportToExcel = () => {
        const table = document.getElementById('transTable');
        if (!table) {
            alert("Table not found");
            return;
        }

        const tableClone = table.cloneNode(true);

        tableClone.querySelectorAll('td, th').forEach(cell => {
            cell.setAttribute('style', 'mso-number-format:"\\@";');
        });


        tableClone.querySelectorAll('thead tr th').forEach(th => {
            th.setAttribute('style', 'background-color: orange; color: balck; font-weight:bold; mso-number-format:"\\@";');
        });
        tableClone.querySelectorAll('tfoot tr td').forEach(td => {

            const currentStyle = td.getAttribute('style') || '';

            td.setAttribute('style', currentStyle + '; background-color: orange; color: black; font-weight: bold;');
        });

        const tableHTML = tableClone.outerHTML.replace(/(\r\n|\n|\r)/gm, '');

        const html = `
        <html xmlns:o="urn:schemas-microsoft-com:office:office"
              xmlns:x="urn:schemas-microsoft-com:office:excel"
              xmlns="http://www.w3.org/TR/REC-html40">
        <head>
            <meta charset="UTF-8">
            <!--[if gte mso 9]>
            <xml>
                <x:ExcelWorkbook>
                    <x:ExcelWorksheets>
                        <x:ExcelWorksheet>
                            <x:Name>FPS Transactions</x:Name>
                            <x:WorksheetOptions>
                                <x:Print><x:ValidPrinterInfo/></x:Print>
                            </x:WorksheetOptions>
                        </x:ExcelWorksheet>
                    </x:ExcelWorksheets>
                </x:ExcelWorkbook>
            </xml>
            <![endif]-->
        </head>
        <body>
            ${tableHTML}
        </body>
        </html>`;

        const blob = new Blob([html], { type: 'application/vnd.ms-excel;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Transaction Details for FPS Id :${fps_id}_${MonthC[parseInt(month) - 1]}_${year}.xls`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };


    //// above export excel
    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsTrans.current) {
            // detailsTrans.current.scrollIntoView({ behavior: 'smooth' , block: 'end'});
            const elementPosition = detailsTrans.current.offsetTop;
            window.scrollTo({
                top: elementPosition,
                behavior: 'smooth'
            });
        }
    }, [loading, error, reportData]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }

    if (error) {
        return <div className="mainhead" align="center">Internal error</div>;
    }

    if (reportData.length === 0) {
        return <div className="mainhead" align="center">No data found</div>;
    }

    return (
        <>
            <br /><br />
            {/* ////margingbotom make tp 10px */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'end', marginBottom: '10px', marginRight: '10%' }}>
                <input
                    type="text"
                    placeholder="Search RC Id"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{ padding: '8px', width: '300px' }}
                />


            </div>

            {/* //// below excel button */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '6%' }}>
                <button
                    className="button button2"
                    onClick={exportToExcel}
                    style={{ padding: '8px 16px' }}
                >
                    Download Excel
                </button>
            </div>


            <br />


            <table id="transTable" align="center" width="90%" border={1} ref={detailsTrans}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={9 + reportData[0].commodityList.length}>
                            {'Transaction Details for FPS Id : ' + fps_id + ' ' + MonthC[parseInt(month) - 1] + '-' + year}
                        </th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={2}>Sl.No</th>
                        <th rowSpan={2}>RC No</th>
                        <th rowSpan={2}>Scheme</th>
                        <th rowSpan={2}>Avail Type</th>
                        <th rowSpan={2}>Receipt No</th>
                        <th rowSpan={2}>Date</th>
                        <th colSpan={reportData[0].commodityList.length}>Qty in Kgs</th>
                        <th rowSpan={2}>Amount(Rs.)</th>
                        <th rowSpan={2}>Portability</th>
                        <th rowSpan={2}>Auth Trans Time</th>
                    </tr>
                    <tr className="tableheader">
                        {reportData[0].commodityList.map((item, index) => (
                            <th key={index}>{item.comm_name_en}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {paginatedData.map((item, index) => (
                        <tr key={item.receiptId}>
                            <td style={{ textAlign: 'center' }}>{index + 1 + (page * rowsPerPage)}</td>
                            <td style={{ textAlign: 'left' }}>{item.existingRcNumber}</td>
                            <td style={{ textAlign: 'left' }}>{item.schemeShortName}</td>
                            <td style={{ textAlign: 'left' }}>{item.auth_type}</td>
                            <td style={{ textAlign: 'right' }}>{item.receiptId}</td>
                            {/* <td style={{ textAlign: 'right' }}>{formatDateToDD_MM_YYYY(item.loginTime)}</td> */}
                            <td style={{ textAlign: 'right' }}>
                                {formatDateToDD_MM_YYYY_HH_MM_SS(item.loginTime)}
                            </td>
                            {item.commodityList.map((item1, index) => (
                                <td key={index} style={{ textAlign: 'right' }}>{item1.sale_qty || '0'}</td>
                            ))}
                            <td style={{ textAlign: 'right' }}>{item.amount}</td>

                            <td style={{ textAlign: 'left' }}>{item.portCheck}</td>
                            <td style={{ textAlign: 'right' }}>{item.transTime}</td>
                        </tr>
                    ))}

                </tbody>
                <tfoot>
                    <tr className="tableheader">
                        <td colSpan={6}>Total</td>
                        {totals.map((total, index) => (
                            <td style={{ textAlign: 'right', fontWeight: 'bold' }} key={index}>{total.toFixed(3)}</td>
                        ))}
                        <td style={{ textAlign: 'right' }}>{amountTotals[0]?.toFixed(3) || '0.000'} </td>
                        <td style={{ textAlign: 'right' }}> </td>
                        <td style={{ textAlign: 'right' }}> </td>

                    </tr>
                </tfoot>
            </table>
            <br />
            <br />
            <div width="75%" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '90%', marginBottom: '5%' }}>
                <PaginationTable
                    count={filteredData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>

        </>
    );
};

export default FPS_Trans_Details;